import "./Footer.scss"
import { FC } from "react"
import appStoreIcon from "../../../assets/images/app-store.png"
import googlePlayIcon from "../../../assets/images/google-play.png"
import { useTranslationLabel } from "../../../hooks/useTranslationLabel"
import { useBranding } from "../../../hooks/useBranding"
import { t } from "i18next"

export const Footer: FC = () => {
  const {
    DOWNLOAD_APP,
    SPAIN,
    TERMS_AN_CONDITIONS,
    PRIVACY_POLICY,
    FAQ,
    CONTACT_US,
  } = useTranslationLabel()
  const { terms_an_conditions,privacy_policy,faq,contact_us,appleStore, googlePlay } = useBranding();

  return (
    <footer className="footer">
      <div className="container">
        <div className="row">
          <div className="col-md-3 col-xs-12">
            <div className="footer_warp">
              <h3>{DOWNLOAD_APP}</h3>
              <div className="app_store">
                <div>
                  <a
                    href={appleStore}
                    target="_blank"
                  >
                    <img src={appStoreIcon} alt="App Store" />
                  </a>
                </div>
                <div>
                  <a
                    href={googlePlay}
                    target="_blank"
                    about=""
                  >
                    <img src={googlePlayIcon} alt="Google Play" />
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-3 col-xs-12">
            <div className="footer_warp">
              <ul className="footer_menu">
                <li>
                  <a
                    href={t(terms_an_conditions)}
                    target="_blank"
                  >
                    {TERMS_AN_CONDITIONS}
                  </a>
                </li>
                <li>
                  <a
                    href={t(privacy_policy)}
                    target="_blank"
                  >
                    {PRIVACY_POLICY}
                  </a>
                </li>
                <li>
                  <a
                    href={t(faq)}
                    target="_blank"
                  >
                    {FAQ}
                  </a>
                </li>
                <li>
                  <a
                    href={t(contact_us)}
                    target="_blank"
                  >
                    {CONTACT_US}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}
